import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LsErrorExceptionClass;
function LsErrorException() {
  if (LsErrorExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static bei(status, error) {
        var $this = this.o4('' + status + ': ' + error.s4b_1);
        captureStack($this, $this.vdr_1);
        $this.tdr_1 = status;
        $this.udr_1 = error;
        return $this;
      }
    }
    initMetadataForClass($, 'LsErrorException');
    LsErrorExceptionClass = $;
  }
  return LsErrorExceptionClass;
}
//region block: exports
export {
  LsErrorException as LsErrorException1ikb4g50zc2ko,
};
//endregion

//# sourceMappingURL=LsErrorException.mjs.map
